import { FilterActionKeys as keys } from './filtersActionKeys';
import { SetFilters, SetFiltersPartial } from './filtersActionTypes';
import { IFiltersState } from './filtersReducer';

export const filtersActionCreators = {
  setFilters: (filterType: keyof IFiltersState, filters: object): SetFilters => ({
    payload: { filters, filterType },
    type: keys.SET_FILTERS
  }),
  setFiltersPartial: (filterType: keyof IFiltersState, filters: object): SetFiltersPartial => ({
    payload: { filters, filterType },
    type: keys.SET_FILTERS_PARTIAL
  })
};
